import { createContext, useContext } from 'react';
import type { GameApi } from './useGame';

export const GameContext = createContext<GameApi | null>(null);

export function useGameContext(): GameApi {
  const ctx = useContext(GameContext);
  if (!ctx) throw new Error('useGameContext must be used within GameProvider');
  return ctx;
}
